// extracted by mini-css-extract-plugin
export default {"tableCellWithButton":"table-cell-with-button__table-cell-with-button__phBTF"};